<div>
	{{snackBarRef.containerInstance.snackBarConfig.data}}
</div>
<!--
<button mat-raised-button color="accent" (click)="snackBarRef.dismiss()">close</button>
-->